<template>
    <ui-modal
        :title="modalTitle"
        ref="modal"
        :small="true"
    >
        <div class="columns">
            <div class="column is-12">
                <label class="label"> {{ transChoice('app.title', 1).titleCase() }} </label>
                <p class="control">
                    <input
                        name="name"
                        class="input is-large"
                        type="text"
                        v-model="form.title"
                        required
                    >

                    <span
                        v-if="form.errors.has('title')"
                        class="help is-danger"
                    >{{ form.errors.first('title') }}</span>
                </p>
            </div>
        </div>

        <div class="columns">
            <div class="column is-4">
                <div v-if="! loading">
                    <h4 class="title is-4">Update to:</h4>

                    <p class="control">
                        <label class="label">Project:</label>
                        <span class="select is-large">
                            <select
                                name="project_id"
                                v-model="projectId"
                            >
                                <option value="0">None</option>
                                <option
                                    v-for="item in projects"
                                    :value="item.id"
                                    :key="item.id"
                                    v-text="item.name"
                                ></option>
                            </select>
                        </span>
                    </p>

                </div>

                <div class="centered loader is-large" v-else></div>
            </div>

            <div class="column is-8">
                <label class="label">{{ trans('app.body').titleCase() }}</label>
                <p class="control">
                    <trumbowyg
                        v-model="form.description"
                        :config="config"
                        class="form-control"
                        name="description"
                    ></trumbowyg>

                    <span
                        v-if="form.errors.has('description')"
                        class="help is-danger"
                    >{{ form.errors.first('description') }}</span>
                </p>
            </div>
        </div>
        <footer slot="footer">
            <a
                class="button is-medium mrs"
                @click="closeModal"
            >{{ trans('app.cancel').titleCase() }}</a>
            <input
                type="button"
                class="button is-success is-medium mrs"
                :value="trans('app.save').titleCase()"
                :disabled="! hasSelectedProject"
                @click="submit"
            >
            <span class="control is-grouped ">
                <span class="control">
                    <label class="checkbox">
                        <input
                            id="notify_account"
                            name="notify_account"
                            type="checkbox"
                            value="true"
                            v-model="form.notify_account"
                        >
                        <strong>{{ trans('app.notify_account').titleCase() }}</strong>
                    </label>
                </span>
            </span>
        </footer>
    </ui-modal>
</template>

<script>
import Trumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/ui/trumbowyg.css';
import Form from 'form-backend-validation';

export default {

    components: {
        Trumbowyg,
    },
    props: {
        accountId: {
            type: Number,
            required: true,
        },
    },

    data () {
        return {
            loading: false,
            projects: [],
            projectId: 0,
            projectUpdate: null,
            form: new Form({
                description: null,
                title: null,
                notify_account: null,
                related_type: null,
                related_id: null,
                project_id: null,
            }),
            config: {
                resetCss: true,
                autogrow: false,
                btns: [
                    ['formatting'],
                    ['strong', 'em', 'del'],
                    ['unorderedList', 'orderedList'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['link'],
                    ['removeformat'],
                    ['fullscreen'],
                    ['viewHTML'],
                ],
            },
        };
    },

    computed: {
        project () {
            let project = _.find(this.projects, {id: this.projectId});

            return project;
        },

        hasSelectedProject () {
            return this.projectId !== 0;
        },

        type () {
            return 'project';
        },

        relatedId () {
            return this.projectId;
        },

        isProjectType () {
            return this.type === 'project';
        },

        modalTitle () {
            let lang_key = 'app.add_new_this';

            if (this.isProjectType) {
                return this.trans(lang_key, {this: this.transChoice('app.project_update', 1)}).titleCase();
            }

            return null;
        },

        storeUpdateRoute () {
            return this.route('project_updates.store');
        },

        fetchProjectsRoute () {
            return this.route('projects.list', {account: this.accountId});
        },
    },

    listeners: {
        async 'open-project-update-general-add-modal' () {
            await this.showModal();
        },
    },

    methods: {
        async showModal () {
            this.$refs.modal.show();
            await this.fetchProjects();
        },

        closeModal () {
            this.$refs.modal.hide();
            this.form.reset();
            this.projectId = 0;
        },

        async submit () {
            try {
                this.form.related_type = this.type;
                this.form.project_id = this.projectId;
                this.form.related_id = this.relatedId;

                await this.form.post(this.storeUpdateRoute, this.form);

                OSPEvent.$emit('project-updates-updated', {});
                this.closeModal();
            } catch (errors) {
                console.error(errors);
            }
        },

        async fetchProjects () {
            this.loading = true;
            try {
                let {data} = await axios.get(this.fetchProjectsRoute);

                this.projects = data.projects;
            } catch (errors) {
                console.error(errors);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
